export default __webpack_public_path__ + "static/media/alexis.da603b27.jpeg";